import DeliverySDK from '@olxeu-a2b/core/src/api/DeliverySDK';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SuspedableResource } from '@olxeu-a2b/delivery-utils/typings/extras';
import suspendable from './suspendable';
import { sdkFactory } from './sdkFactory';

export default function suspendableSDK<T>(
  caller: (sdk: DeliverySDK) => Promise<T>,
): SuspedableResource<T> {
  return suspendable<T>(caller(sdkFactory()));
}
